import axios from "axios";
import authService from "../services/AuthService";

//=============================================================================
// Configuración base para el servidor principal
//=============================================================================
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // 'http://192.168.110.3:8083', // Ajusta la URL base según tu entorno
  // Puedes configurar headers, timeouts, etc. adicionalmente
});

// Interceptor para inyectar el token en cada petición (opcional)
apiClient.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    //   const jwt_raw = tk.split("Bearer ")[1];
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response, // Si la respuesta es correcta, la pasamos tal cual
  (error) => {
    // Manejo de errores
    console.error("Axios Error:", error);

    if (error.response) {
      // Error con respuesta (404, 500, etc.)
      console.log("Response Error Data:", error.response.data);
      console.log("Response Error Status:", error.response.status);

      if (error.response.status === 401) {
        authService.deleteToken();

        const currentUrl = encodeURIComponent(window.location.href);
        const redirectUrl = `${process.env.REACT_APP_FALLBACK_NO_PROJECT_URL}/redirect?url=${currentUrl}`;

        window.location.href = redirectUrl;
      }
    } else if (error.request) {
      // Error con la solicitud (si no hubo respuesta)
      console.log("Request Error:", error.request);
    } else {
      // Otro tipo de error (ej. problemas con la configuración)
      console.log("Error:", error.message);
    }

    // Puedes manejar el error aquí y devolver una respuesta por defecto
    return Promise.reject(error);
  }
);

export default apiClient;
